<template>
    <div class="tw:space-y-4">
        <div class="tw:mb-4">
            <h2 class="tw:text-sm tw:font-semibold tw:text-gray-500 tw:uppercase tw:tracking-wide tw:my-1">
                Datos de los responsables
            </h2>
        </div>

        <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-6">
            <!-- Responsable 1 -->
            <div class="tw:space-y-4">
                <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:uppercase tw:tracking-wide">
                    Responsable 1
                </p>
                <BaseInputText
                    label="Nombre responsable 1"
                    name="nombre_responsable"
                    rules="required"
                    :value="value.nombre_responsable"
                    @input="emitChange('nombre_responsable', $event)"
                />
                <BaseInputText
                    label="Apellidos responsable 1"
                    name="apellidos_responsable"
                    rules="required"
                    :value="value.apellidos_responsable"
                    @input="emitChange('apellidos_responsable', $event)"
                />
                <BaseInputText
                    label="DNI responsable 1"
                    name="dni_responsable"
                    rules="required"
                    :value="value.dni_responsable"
                    @input="emitChange('dni_responsable', $event)"
                />
                <BaseInputText
                    label="Email responsable 1"
                    name="email_responsable"
                    rules="required"
                    :value="value.email_responsable"
                    @input="emitChange('email_responsable', $event)"
                />
                <BaseInputText
                    label="Teléfono responsable 1"
                    name="telefono_responsable"
                    rules="required"
                    :value="value.telefono_responsable"
                    @input="emitChange('telefono_responsable', $event)"
                />
            </div>

            <!-- Responsable 2 -->
            <div class="tw:space-y-4">
                <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:uppercase tw:tracking-wide">
                    Responsable 2 (opcional)
                </p>
                <BaseInputText
                    label="Nombre responsable 2"
                    name="nombre_responsable_2"
                    :value="value.nombre_responsable_2"
                    @input="emitChange('nombre_responsable_2', $event)"
                />
                <BaseInputText
                    label="Apellidos responsable 2"
                    name="apellidos_responsable_2"
                    :value="value.apellidos_responsable_2"
                    @input="emitChange('apellidos_responsable_2', $event)"
                />
                <BaseInputText
                    label="DNI responsable 2"
                    name="dni_responsable_2"
                    :value="value.dni_responsable_2"
                    @input="emitChange('dni_responsable_2', $event)"
                />
                <BaseInputText
                    label="Email responsable 2"
                    name="email_responsable_2"
                    :value="value.email_responsable_2"
                    @input="emitChange('email_responsable_2', $event)"
                />
                <BaseInputText
                    label="Teléfono responsable 2"
                    name="telefono_responsable_2"
                    :value="value.telefono_responsable_2"
                    @input="emitChange('telefono_responsable_2', $event)"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue';

    const props = defineProps({
        value: { type: Object, required: true },
    });

    const emit = defineEmits(['change']);

    function emitChange(field, value) {
        emit('change', { field, value });
    }
</script>
